<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [variante]="variante"
  [icon]="icon"
  [(ngModel)]="tiposVendas"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()">
</sgt-multi-select>
